import { Injectable } from '@angular/core';
import { AnyHandler, SimpleFunction } from 'src/app/types/@types/sl-v-types';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { Subject } from 'rxjs';
import { Decorable, Dict } from 'src/app/types/decorable';
import { SLLayer } from 'src/app/model/sl-layer';

export type ExportContentOption = 'res-all' | 'res-sel' | 'res-unsel' | 'mem' | 'all'
export type ExportTypeOption = 'csv' | 'xls' | 'shp' | 'kmz' | 'gallery';
export type ExportableColumnOption = 'all' | 'visible' | 'anchored' | 'unanchored';
export type ExportableColumnOptionDict = Dict | {
  [key in ExportableColumnOption]: string;
}
export type ExportTypeOptionsDict = Dict | {
  [key in ExportTypeOption]: string;
}
export type ExportContentOptionsDict = Dict | {
  [key in ExportContentOption]: string;
}


export interface IDataExportContext {
  GetTypeOptions(): ExportTypeOptionsDict,
  GetContentOptions(type: ExportTypeOption): ExportContentOptionsDict,
  GetColumnExportOptions(): ExportableColumnOptionDict;// subset of 'all'|'visible'|'anchored'|'unanchored'
  GetExportableColumns(cols: ExportableColumnOption): Array<string>;
  GetExportData(
    typeOption: ExportTypeOption,
    contentOption: ExportContentOption,
    optData?: Array<any>
  ): Array<any> | '*' | string; // * or gid array or comma separated gids or records
  GetMap(): ISLMap;
  GetSLLayer(): SLLayer;
  GetMetaProvider?(): SimpleFunction;
  GetRawMode(): boolean;
  HasGroupings(): boolean;
  HasSummaries(): boolean;
}

export type ExportDialogParams = Decorable | {
  context: IDataExportContext
}
export type ExportDialogShowParams = {
  handler: AnyHandler,
  map?: ISLMap,
  params: ExportDialogParams
}

@Injectable({
  providedIn: 'root'
})
export class ExportDataDialogService {
  public request$: Subject<any> = new Subject();
  constructor() { }

  Show(handler: AnyHandler, map: ISLMap, params: ExportDialogParams) {
    this.request$.next({
      handler: (handler),
      map: (map),
      params: (params)
    });
  }


}
